// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2O5Wn","content":"styles_content__1Mu8N","selectAll":"styles_selectAll__1-CN_"};